import { RendererFieldType } from '../models/renderer.models';

/**
 * Returns the Material icon name for a given form-field type.
 * Used in the structure tree to visually identify each field.
 */
export function fieldIcon(type: RendererFieldType | undefined): string {
  switch (type) {
    case RendererFieldType.Text:        return 'short_text';
    case RendererFieldType.Number:      return 'pin';
    case RendererFieldType.Date:        return 'calendar_today';
    case RendererFieldType.Time:        return 'access_time';
    case RendererFieldType.Select:      return 'arrow_drop_down_circle';
    case RendererFieldType.Checkbox:    return 'check_box';
    case RendererFieldType.PhotoPicker: return 'photo_camera';
    case RendererFieldType.Divider:     return 'horizontal_rule';
    default:                            return 'text_fields';
  }
}

/**
 * Returns a human-readable German label for a form-field type.
 * Used in the structure tree to show the type beside each field.
 */
export function fieldTypeLabel(type: RendererFieldType | undefined): string {
  switch (type) {
    case RendererFieldType.Text:        return 'Textfeld';
    case RendererFieldType.Number:      return 'Zahl';
    case RendererFieldType.Date:        return 'Datum';
    case RendererFieldType.Time:        return 'Uhrzeit';
    case RendererFieldType.Select:      return 'Auswahl';
    case RendererFieldType.Checkbox:    return 'Checkbox';
    case RendererFieldType.PhotoPicker: return 'Fotofeld';
    case RendererFieldType.Divider:     return 'Trenner';
    default:                            return type ?? '–';
  }
}
